export const getEducationalFacilities = (state) =>
  state.educationalFacility.educationalFacilityList;
export const getEducationalFacilityDetails = (state) =>
  state.educationalFacility.educationalFacilityDetails;
